export const USER_INTERACTION = 'user-interaction';

export enum SpanType {
    USER_INTERACTION = 'user-interaction'
}

export const ComponentNames = {
    SignInButton: 'sign_in_button',
    GetStartedButton: 'get_started_button',
    ProfileDropdown: 'profile_dropdown'
};
